/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One time-series segment for the citations line chart.
 */
export type DashboardCitationCountResponse = {
  period: DashboardCitationCountResponse.period
  counts: Array<number>
  dates: Array<string>
}
export namespace DashboardCitationCountResponse {
  export enum period {
    PRIMARY = 'primary',
    COMPARE = 'compare',
  }
}
